// extracted by mini-css-extract-plugin
export default {"confirmModal":"ConfirmModal_confirmModal__k7kpg","nextButton":"ConfirmModal_nextButton__G6Hyp"};